import React from 'react'
import { Fragment, useRef, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import { convertSchoolAbbreviationToFullName } from '../../../Calendar/calendarFunctions'

const FollowingEventsFlow = ({open, setOpen, abortCancellationFlow, event, setStudentDiscontinuationForm}) => {
    const [selectedOption, setSelectedOption] = useState('choose')
    const cancelButtonRef = React.useRef(null)

    const continueToNextStep = () => {
        setStudentDiscontinuationForm(true)
        setOpen(false)
    }

    const rescheduleStudent = () => {
        abortCancellationFlow(false)
        setOpen(false)
    }

    return (
        <Transition.Root show={open} as={Fragment}>
          <Dialog as="div" className="relative z-30" initialFocus={cancelButtonRef} onClose={setOpen}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>
    
            <div className="fixed inset-0 z-10 overflow-y-auto">
              <div className="flex min-h-full items-center justify-center p-4 text-center sm:items-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                    <div className="sm:flex sm:items-start">
                      <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                        <ExclamationTriangleIcon className="h-6 w-6 text-red-600" aria-hidden="true" />
                      </div>
                      <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                        <Dialog.Title as="h3" className="text-base font-semibold leading-6 text-gray-900">
                          What happened?
                        </Dialog.Title>
                        <div className="mt-2">
                        <div>
                        <div>
                          <select
                            id="location"
                            name="location"
                            className="mt-2 block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6"
                            defaultValue="choose"
                            onChange={(e) => setSelectedOption(e.target.value)}
                          >
                            <option value="choose">Choose an option</option>
                            <option value="discontinuing">Student is discontinuing with {convertSchoolAbbreviationToFullName(event.school)} </option>
                            <option value="changing-teacher">Student is switching teachers</option>
                            <option value="taking-break">Student is taking a break</option>
                            <option value="reschedule">Student is switching to another day</option>
                          </select>
                        </div>
                      </div>
                        </div>
                      </div>
                    </div>
                    <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                      {selectedOption === 'reschedule' ? <button
                        type="button"
                        className="inline-flex w-full justify-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
                        onClick={() => rescheduleStudent(false)}
                      >
                        RESCHEDULE STUDENT
                      </button>
                      :
                      <button
                        type="button"
                        className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
                        onClick={() => continueToNextStep()}
                      >
                        Continue to delete
                      </button>
                      }
                      <button
                        type="button"
                        className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                        onClick={() => abortCancellationFlow(false)}
                        ref={cancelButtonRef}
                      >
                        Go Back
                      </button>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
      )
}
export default FollowingEventsFlow